import React from 'react'
import { InputNumber, Select } from 'antd'
import { advancedAnalyticsMonthOptions } from '../../../../ResultPanel/Plot/MonthOptions'
import { Label } from "../../../../../common/Label/Label"
import styles from '../../../../ResultPanel/Style/LayoutPanel.module.scss'
import { IBestDataset, IPlotVariable } from '../../../../../../types/analytics'

interface HistogramAdditionalInputProps {
  variablesY: IPlotVariable[] | null
  variableY: IPlotVariable | null
  onVariableYChange: (value: any) => void
  month: any
  datasets: IBestDataset[]
  categories: string[]
  directionalDataset: string | null
  onDirectionalDatasetChange: (value: string) => void
  directionalInterval: number
  onDirectionalIntervalChange: (value: number | null) => void
  magnitudeInterval: number
  onMagnitudeIntervalChange: (value: number | null) => void
  onMonthChange: (value: any) => void
  isLoading: boolean
}

const intervalOptions = [
  { value: 1, label: 'Omni' },
  { value: 2, label: '180°' },
  { value: 3, label: '120°' },
  { value: 4, label: '90°' },
  { value: 6, label: '60°' },
  { value: 8, label: '45°' },
  { value: 10, label: '36°' },
  { value: 12, label: '30°' },
  { value: 15, label: '24°' },
  { value: 16, label: '22.5°' },
  { value: 18, label: '20°' },
  { value: 24, label: '15°' },
  { value: 30, label: '12°' },
  { value: 32, label: '11.25°' },
  { value: 36, label: '10°' },
  { value: 64, label: '5.625°' },
  { value: 72, label: '5°' }
];


export default function HistogramAdditionalInput({
   variablesY,
   variableY,
   onVariableYChange,
   month,
   onMonthChange,
   datasets,
   categories,
   isLoading,
   directionalDataset,  
   onDirectionalDatasetChange,
   directionalInterval,
   onDirectionalIntervalChange,
   magnitudeInterval,
   onMagnitudeIntervalChange
 }: HistogramAdditionalInputProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '16px',
      gap: '12px',
      height: '100%'
    }}>
      
      <Label label="Directional Dataset" className={styles.actionItem}>
        <Select
          value={directionalDataset}
          id="Analytics-Histogram-DatasetY_Input"
          size="small"
          style={{ width: '100%' }}
          onChange={onDirectionalDatasetChange}
          disabled={isLoading}
        >
         {categories.map((category: string) => (
            <Select.OptGroup key={category} label={category}>
              {datasets
                .filter((item) => item.label === category)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.value}
                  </Select.Option>
                ))}
            </Select.OptGroup>
          ))}
        </Select>
      </Label>

      <Label label="Directional Variable" className={styles.actionItem}>
        <Select
          value={variableY?.Index ? variableY.Index : 0}
          id="Analytics-Histogram-VariableY_Input"
          size="small"
          style={{ width: '100%' }}
          onChange={onVariableYChange}
          disabled={isLoading}
        >
          {variablesY?.map((item) => (
            <Select.Option key={item.Index} value={item.Index}>
              {item.Name}
            </Select.Option>
          ))}
        </Select>
      </Label>

      <Label label="Directional Interval" className={styles.actionItem}>
      <Select
        value={directionalInterval}
        id="Analytics-Histogram-DirectionalInterval_Select"
        size="small"
        style={{ width: '100%' }}
        onChange={onDirectionalIntervalChange}
        disabled={isLoading}
        placeholder="Pilih interval"
      >
        {intervalOptions.map(option => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
      </Label>

      <Label label="Magnitude No. Intervals" className={styles.actionItem}>
        <InputNumber
          value={magnitudeInterval}
          id="Analytics-Histogram-MagnitudeInterval_Input"
          size="small"
          step={1}
          min={2}
          max={36}
          style={{ width: '100%' }}
          onChange={onMagnitudeIntervalChange}
          disabled={isLoading}
        />
      </Label>

      <Label label="Month" className={styles.actionItem}>
        <Select
          id="Analytics-Histogram-Month_Input"
          value={month}
          size="small"
          style={{ width: '100%' }}
          onChange={onMonthChange}
          options={advancedAnalyticsMonthOptions}
          disabled={isLoading}
        />
      </Label>

      <div style={{ flex: 1 }} />
    </div>
  )
}
